import { MultiSelectOption, MultiSelectType, MultiSelectValue } from 'models/multi-select.model';

export const MULTI_SELECT_DATA: MultiSelectOption[] = [
  {
    type: MultiSelectType.DATE,
    title: 'FORMS.MULTISELECT.DATE.TITLE',
    items: [
      { value: MultiSelectValue.YY, title: 'FORMS.MULTISELECT.DATE.YY' },
      { value: MultiSelectValue.YYYY, title: 'FORMS.MULTISELECT.DATE.YYYY' },
      { value: MultiSelectValue.MMYYYY, title: 'FORMS.MULTISELECT.DATE.MMYYYY' },
      { value: MultiSelectValue.DDMMYYYY, title: 'FORMS.MULTISELECT.DATE.DDMMYYYY' }
    ]
  },
  {
    type: MultiSelectType.USER_SHORT,
    title: 'FORMS.MULTISELECT.USER_SHORT.TITLE',
    items: [
      { value: 'xy', title: '' },
      { value: 'XY', title: '' },
      { value: 'xY', title: '' },
      { value: 'XYy', title: '' }
    ]
  },
  {
    type: MultiSelectType.OFFER_DATA,
    title: 'FORMS.MULTISELECT.OFFER_DATA.TITLE',
    items: [
      { value: MultiSelectValue.OFFER_NR, title: 'FORMS.MULTISELECT.OFFER_DATA.OFFER_NR' },
      { value: MultiSelectValue.OBJECT_NR, title: 'FORMS.MULTISELECT.OFFER_DATA.OBJECT_NR' }
    ]
  },
  {
    type: MultiSelectType.CUSTOMER_DATA,
    title: 'FORMS.MULTISELECT.CUSTOMER_DATA.TITLE',
    items: [
      { value: MultiSelectValue.CUSTOMER_NAME, title: 'FORMS.MULTISELECT.CUSTOMER_DATA.CUSTOMER_NAME' },
      { value: MultiSelectValue.CUSTOMER_NR, title: 'FORMS.MULTISELECT.CUSTOMER_DATA.CUSTOMER_NR' }
    ]
  },
  {
    type: MultiSelectType.FREE_TEXT,
    title: 'FORMS.MULTISELECT.FREE_TEXT.TITLE',
    items: [{ value: '', title: '' }]
  },
  {
    type: MultiSelectType.OFFER_NUMBER,
    title: 'FORMS.MULTISELECT.OFFER_NUMBER.TITLE',
    items: [
      { value: '1', title: '1' },
      { value: '01', title: '01' },
      { value: '001', title: '001' },
      { value: '0001', title: '0001' },
      { value: '00001', title: '00001' },
      { value: '000001', title: '000001' }
    ]
  }
];
